<template>
  <v-dialog
    v-model="dialogParrainage"
    max-width="400"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="justify-start text-none no-bg-v-btn drawer-v-btn"
        text
        v-bind="attrs"
        v-on="on"
      >
        {{ $t('parrainage', { type: user.is_petite_source ? 'Petite Source' : 'Piscinelle' }) }}
      </v-btn>
    </template>

    <v-card class="py-4">
      <v-card-text>
        <p>
          {{
            $t('parrainage-intro', {
              type: user.is_petite_source ? 'Petite Source' : 'Piscinelle'
            })
          }}
        </p>
      </v-card-text>

      <v-card-actions class="flex-wrap justify-center">
        <v-form
          ref="formParrainage"
          v-model="validParrainage"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="prenom"
                outlined
                :label="$t('parrainage-prenom')"
                required
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="nom"
                outlined
                :label="$t('parrainage-nom')"
                required
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="email"
                outlined
                :rules="emailRules"
                :label="$t('parrainage-email')"
                required
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="telephone"
                outlined
                :rules="telephoneRules"
                :label="$t('parrainage-telephone')"
              />
            </v-col>
          </v-row>

          <v-btn
            :disabled="!validParrainage"
            :loading="loading"
            class="white--text mt-2 mr-2"
            :class="user.is_petite_source ? 'background-ps-primary primary-ps-hover ps-disabled-color' : 'background-primary primary-hover'"
            @click="envoyerParrainage()"
          >
            {{ $t('envoyer-parrainage') }}
          </v-btn>

          <v-btn
            class="mt-2"
            @click="dialogParrainage = false"
          >
            {{ $t('annuler') }}
          </v-btn>
        </v-form>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Parrainage',

  data () {
    return {
      dialogParrainage: false,
      loading: false,

      validParrainage: true,

      prenom: '',
      nom: '',
      email: '',
      telephone: '',

      emailRules: [
        value => !!value || this.$t('champ-requis'),
        value => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          return pattern.test(value) || this.$t('mail-valide')
        }
      ],

      telephoneRules: [
        value => {
          const pattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
          return !value || pattern.test(value) || this.$t('telephone-valide')
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'user'
    ])
  },

  methods: {
    envoyerParrainage () {
      this.loading = true

      this.$store.dispatch('envoyerParrainage', {
        prenom: this.prenom,
        nom: this.nom,
        email: this.email,
        telephone: this.telephone,
        commercialEmail: this.user.vendeur && this.user.vendeur.email
          ? this.user.vendeur.email
          : ''
      })
        .then(() => {
          this.dialogParrainage = false
          this.loading = false
        })
    }
  }
}
</script>
